<template>
    <div id="app">
        <!--
       属性:
           color: String类型。默认'#dedede'。粒子颜色。
           particleOpacity: Number类型。默认0.7。粒子透明度。
           particlesNumber: Number类型。默认80。粒子数量。
           shapeType: String类型。默认'circle'。可用的粒子外观类型有："circle","edge","triangle", "polygon","star"。
           particleSize: Number类型。默认80。单个粒子大小。
           linesColor: String类型。默认'#dedede'。线条颜色。
           linesWidth: Number类型。默认1。线条宽度。
           lineLinked: 布尔类型。默认true。连接线是否可用。
           lineOpacity: Number类型。默认0.4。线条透明度。
           linesDistance: Number类型。默认150。线条距离。
           moveSpeed: Number类型。默认3。粒子运动速度。
           hoverEffect: 布尔类型。默认true。是否有hover特效。
           hoverMode: String类型。默认true。可用的hover模式有: "grab", "repulse", "bubble"。
           clickEffect: 布尔类型。默认true。是否有click特效。
           clickMode: String类型。默认true。可用的click模式有: "push", "remove", "repulse", "bubble"。
           /*如果想做背景图片 可以给标签一个class 直接添加背景图 如果要换背景可以直接给#particles-js这个id添加背景图片和颜色即可，这个id是默认的*/
       -->
        <vue-particles
            color="#fff"
            :particleOpacity="0.2"
            :particlesNumber="60"
            shapeType="circle"
            :particleSize="2"
            linesColor="#fff"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.1"
            :linesDistance="150"
            :moveSpeed="1"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="false"
            clickMode="push"
            class="lizi"
        >
        </vue-particles>
        <!--<router-view :clientHeight="clientHeight" :style="{'height': clientHeight}"></router-view>-->
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app',
    data() {
        return {
            clientHeight: document.documentElement.clientHeight + 'px', //// 这里是给到了一个默认值 （这个很重要）
        }
    },
    mounted() {
        // 获取浏览器可视区域高度
        // this.clientHeight = document.documentElement.clientHeight; //document.body.clientWidth;
        //console.log(self.clientHeight);
        /* this.$nextTick(() => {
        window.onresize = () => {
          setTimeout( () => {
            this.clientHeight = document.documentElement.clientHeight + 'px';
          }, 500)
        };
      });*/
    },
    components: {
        // HelloWorld
    },
}
</script>

<style lang="scss">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*position: fixed;*/
    color: #2c3e50;
    width: 100%;
    height: 100%;
    /*margin-top: 60px;*/
    padding: 0;
    margin: 0;
    /*min-width: 1366px;*/
    /*min-height: 768px;*/

    #particles-js {
        background-image: url(./assets/images/register-bg.png);
        /*background-size: cover;*/
        position: fixed;
        background-size: 100% 100%;
        transition: all 0.5s ease 0s;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        /*background-color: #2d3a4b;*/
        min-width: 1366px;
        min-height: 768px;
    }
}
</style>
